function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var t = /*#__PURE__*/function () {
  function t() {
    _classCallCheck(this, t);
  }

  _createClass(t, [{
    key: "U",
    value: function U(a) {}
  }, {
    key: "changeUser",
    value: function changeUser() {
      var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
    }
  }, {
    key: "clearData",
    value: function clearData() {
      var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
    }
  }]);

  return t;
}();

export { t as default };